/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inactivated/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Date from './Date/index'
import Person from './Person/index'
import React from 'react'
import Reason from './Reason/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Inactivated({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate/Status/InfoTooltip/Content/Inactivated"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Inactivated.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 text="Inactivated by"
/>
<Person
  viewPath={`${viewPath}/Person`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 text="on"
/>
<Date
  viewPath={`${viewPath}/Date`}
/>
<Reason
  viewPath={`${viewPath}/Reason`}
/>
</div>
{children}
</React.Fragment>)
}